import { memo } from "react"

const IconRocket = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M21.2517 4.52706C21.2521 4.29078 21.2054 4.0568 21.1141 3.83883C21.0229 3.62087 20.8891 3.42333 20.7205 3.2578C20.5519 3.09227 20.3519 2.96209 20.1323 2.8749C19.9127 2.78771 19.6779 2.74526 19.4417 2.75006C18.4463 2.7427 17.4611 2.95079 16.5537 3.36006C16.0173 3.59396 15.521 3.91047 15.0827 4.29806L7.38766 12.0041C6.77548 12.6172 6.43164 13.4482 6.43164 14.3146C6.43164 15.181 6.77548 16.012 7.38766 16.6251C8.00073 17.2369 8.8315 17.5806 9.69766 17.5806C10.5638 17.5806 11.3946 17.2369 12.0077 16.6251L19.7147 8.91906C20.1048 8.47063 20.4211 7.96294 20.6517 7.41506C21.0575 6.5069 21.2622 5.52172 21.2517 4.52706Z"
        stroke="#7B78E1"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.7763 4.60309C16.022 6.42747 17.6055 7.99639 19.4413 9.22509M9.69733 9.69309L7.26733 9.20309C6.82643 9.1186 6.37158 9.14292 5.94221 9.27397C5.51284 9.40501 5.12191 9.63881 4.80333 9.95509L2.91833 11.8401C2.84007 11.9157 2.78623 12.013 2.76373 12.1194C2.74123 12.2258 2.75111 12.3366 2.79209 12.4374C2.83307 12.5382 2.90328 12.6244 2.99368 12.6849C3.08408 12.7455 3.19053 12.7776 3.29933 12.7771H6.56933M14.3193 14.3151L14.7993 16.7351C14.8894 17.175 14.8687 17.6303 14.7392 18.0602C14.6097 18.4902 14.3754 18.8811 14.0573 19.1981L12.1613 21.0941C12.0845 21.1696 11.9871 21.2206 11.8813 21.2407C11.7756 21.2609 11.6662 21.2493 11.5671 21.2073C11.4679 21.1654 11.3834 21.095 11.3241 21.0051C11.2649 20.9152 11.2337 20.8098 11.2343 20.7021V17.4321M5.06533 18.9361L12.0083 12.0041"
        stroke="#7B78E1"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(IconRocket)
